import { render } from "./ClientListFilters.vue?vue&type=template&id=4a4b6220&scoped=true"
import script from "./ClientListFilters.vue?vue&type=script&lang=js"
export * from "./ClientListFilters.vue?vue&type=script&lang=js"

import "./ClientListFilters.vue?vue&type=style&index=0&id=4a4b6220&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4b6220"]])

export default __exports__